import React from 'react'

const ProgressBar = ({ current, total }) => {
  const progress = (current / total) * 100

  return (
    <div>
      <div className="flex items-center">
        <span className="text-green-600 font-bold">{current}</span>
        <span className="text-gray-600 mx-1">/</span>
        <span className="text-gray-600">{total} Days</span>
      </div>
      <div className="mt-1 w-full flex-1 h-[2px] bg-gray-200 rounded-full relative">
        <div
          className="absolute top-[-1px] h-[4px] bg-green-600 rounded-full"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  )
}

export default ProgressBar
